/* eslint-disable react/prop-types */
import { useState, useEffect, useCallback } from 'react';
import useConnectionContext from '@hooks/useConnectionContext';
import { useEffectOnce } from '@hooks';
import request from '@api';
import { usePlaidLink } from 'react-plaid-link';
import cx from 'classnames';
import PlaidLogo from '@assets/plaid_logo.svg';
import StripeLogo from '@assets/stripe_logo.svg';
import { getRASettings } from '@/api/getSettings';
import { locale } from './BankStripe/const';

import BankStripe from './BankStripe';
import classes from './PaymentCard.module.css';

const usePaymentConnection = () => {
  const { queryConnection } = useConnectionContext();
  const [token, setToken] = useState(null);
  const isOAuthRedirect = window.location.href.includes('oauth_state_id=');

  // generate a link_token when component mounts
  useEffectOnce(() => {
    if (isOAuthRedirect) {
      setToken(localStorage.getItem('PLAID_LINK_TOKEN'));
    }
  }, [isOAuthRedirect]);

  const createLinkToken = async () => {
    const res = await request('create-plaid-link-token', { path: '/gateway/payment-service/api/open-platform/' }).catch(console.log);
    const { code, data: linkToken } = res || {};
    if (code === 0) {
      setToken(linkToken);
      localStorage.setItem('PLAID_LINK_TOKEN', linkToken);
    }
  };
  const plaidLinkConfig = {
    onSuccess: async (publicToken) => {
      await request('plaid-onboarding', { path: '/gateway/payment-service/api/open-platform/', method: 'POST', body: { publicToken } }).catch(console.log);
      await queryConnection();
    },
    onLoad: () => {
      console.log('plaid loaded');
    },
    token,
  };
  if (isOAuthRedirect) {
    plaidLinkConfig.receivedRedirectUri = window.location.href;
  }
  const { open, ready } = usePlaidLink(plaidLinkConfig);

  useEffectOnce(() => {
    if (isOAuthRedirect && ready) {
      open();
    }
  }, [ready, open, isOAuthRedirect]);

  return {
    openPlaidLink: open, createLinkToken,
  };
};
function ConnectionCard({
  data, cxname = '',
}) {
  const {
    connected = true, title, icon, info, name,
  } = data || {};
  const [payment, setPayment] = useState('');
  const account = info?.padStart(16, '*');
  const { openPlaidLink, createLinkToken } = usePaymentConnection(payment);
  const [isMerchant, setIsMerchant] = useState(false); // return to merchant 不显示stripe绑卡
  const [isShowBank, setIsShowBank] = useState(false); // 非USD不显示US bank account
  const handleChange = (e) => {
    const { value } = e.target;
    setPayment(value);
    if (value === 'plaid') {
      createLinkToken();
    }
  };
  const getData = async () => {
    try {
      const { code, data: raSettingsData = {} } = await getRASettings();
      if (code === 0) {
        setIsMerchant(raSettingsData?.returnMethodVO?.returnToMerchant);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const fetchMetricsData = useCallback(async () => {
    try {
      const { code, data: { currencyCode = 'USD' } = {} } = await request('merchant-metrics');
      if (code === 0) {
        setIsShowBank(currencyCode === 'USD');
      }
    } catch (e) {
      console.log(e);
    }
  });
  useEffect(() => {
    if (!connected) {
      getData();
      fetchMetricsData();
    }
  }, [connected]);
  return (
    <div className={cx([classes.main_card], cxname)}>
      <div className={classes.mod_title}>{(title || '').toUpperCase()}</div>
      <div className={classes.mod_content}>
        {
          connected
            ? (
              <div className={classes.mod_connected}>
                <div className={classes.mod_info}>
                  <img src={icon} className={classes.mod_img} alt="" />

                  {/* <div className={classes.mod_platform_name}>{name}</div> */}
                  <div className={classes.mod_platform_info}>
                    {name ? locale.plaid.en : locale.stripe.en}
                    :&nbsp;
                    {account}
                  </div>
                </div>
              </div>
            )
            : (
              <div className={classes.payment_form}>
                <div className={classes.form_method}>
                  {!isMerchant
                    && (
                      <div className={classes.radio_item}>
                        <input id="stripe" type="radio" className={classes.radio} name="payment" value="stripe" checked={payment === 'stripe'} onChange={handleChange} />
                        <label htmlFor="stripe">{locale.stripe.en}</label>
                      </div>
                    )}
                  {isShowBank && (
                    <div className={classes.radio_item}>
                      <input id="plaid" type="radio" className={classes.radio} name="payment" value="plaid" checked={payment === 'plaid'} onChange={handleChange} />
                      <label htmlFor="plaid">{locale.plaid.en}</label>
                    </div>
                  )}

                </div>
                <div>
                  {payment === 'plaid' && (
                    <div className={classes.bind_card}>
                      <img src={PlaidLogo} alt="" className={classes.sdk_logo} />
                      <div onClick={openPlaidLink} className={classes.plaid_btn}>
                        Connect with Plaid
                      </div>
                    </div>
                  )}
                  {payment === 'stripe' && (
                    <div className={classes.bind_card}>
                      <img src={StripeLogo} alt="" className={classes.sdk_logo} />
                      <BankStripe />
                    </div>
                  )}
                </div>
              </div>

            )
        }
      </div>
    </div>
  );
}
export default function PaymentCard() {
  const {
    isLoading, payment,
  } = useConnectionContext();

  return <ConnectionCard isLoading={isLoading} data={payment} />;
}
